import React from 'react';

import { Helmet } from 'react-helmet';

interface PageTitleProps {
  title?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({
  title = 'One Real Mortgage',
}) => (
  <Helmet>
    <title>{title}</title>
  </Helmet>
);
export default PageTitle;
